//跨域代理前缀
// const API_PROXY_PREFIX='/api'
// const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : API_PROXY_PREFIX
// const BASE_URL = process.env.VUE_APP_API_BASE_URL
// const UPLOAD_URL = process.env.VUE_APP_API_UPLOAD_URL
let BASE_URL = ''

// 调整 BASE_URL 获取机制
// 1.生产环境 从地址栏获取
// 2.开发环境 从本地获取

// 开发环境
if(process.env.NODE_ENV == 'development'){
  BASE_URL = process.env.VUE_APP_API_BASE_URL
}else{
  BASE_URL = window.location.origin + '/complaint_data_service'
}
module.exports = {
    LOGIN:`${BASE_URL}/account/ai`,
    SETTING:`${BASE_URL}/ai/set`,
    BASE_URL
}